import extendWretchError from '@/modules/query-client/functions/extendWretchError';
import type { CommonWretchErrorHandlerMap } from '@/modules/query-client/types/CommonWretchErrorHandlerMap';
import type { WretchInstance } from '@/modules/query-client/types/WretchInstance';
import type { WretchInstanceResponseChain } from '@/modules/query-client/types/WretchInstanceResponseChain';
import type { WretchError } from 'wretch/resolver';

/**
 * Attach common error handlers to a wretch instance response chain
 * @param responseChain - The wretch instance response chain
 * @param errorClassMap - The error class map
 * @returns The wretch instance response chain with the common error handlers attached.
 */
export default function attachCommonWretchErrorHandlers(
  responseChain: WretchInstanceResponseChain,
  errorClassMap: CommonWretchErrorHandlerMap = new Map()
) {
  return Array.from(errorClassMap.entries()).reduce(
    (instance, [key, ClassConstructor]) => {
      const errorHandler = (
        originalError: WretchError,
        requeset: WretchInstance
      ) => {
        throw new ClassConstructor(extendWretchError(originalError, requeset));
      };
      return typeof key === 'number'
        ? instance.error(key, errorHandler)
        : instance[key](errorHandler);
    },
    responseChain
  );
}
